import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleSwitch, selectedTeamIdsChange, popUpMenuChange, selectedCardsGroupsChange } from '../../actions/index';
import { findDuplicateTeamGroups } from '../../functions/finder.js';
import { _ } from '../../functions/translator.js';
import { ToggleActions } from '../../constants/constants.js';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';

class TeamSelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selections: {},
        };
    }

    handleClose = () => {
        if (this.props.teamSelectorSwitch) {
            this.props.toggleSwitch(ToggleActions.TEAM_SELECTOR);
        }
    }

    handleSelectionChange = (cardsGroupId, event) => {
        this.setState({
            selections: {
                ...this.state.selections,
                [cardsGroupId]: event.target.value,
            }
        });
    }

    handleContinue = () => {
        const { autoAssign, duplicates } = findDuplicateTeamGroups(
            this.props.standByCardsGroups,
            this.props.projectData.cards_groups,
            this.props.projectData.teams
        );
        const selectedTeamIds = { ...autoAssign };
        for (const cardsGroupId of Object.keys(duplicates)) {
            if (this.state.selections[cardsGroupId]) {
                selectedTeamIds[cardsGroupId] = this.state.selections[cardsGroupId];
            }
        }
        this.props.selectedTeamIdsChange(selectedTeamIds);
        this.props.toggleSwitch(ToggleActions.TEAM_SELECTOR);
        this.props.toggleSwitch(ToggleActions.RELEASE_DATE);
    }

    allSelected = (duplicates) => {
        for (const cardsGroupId of Object.keys(duplicates)) {
            if (!this.state.selections[cardsGroupId]) {
                return false;
            }
        }
        return true;
    }

    getCardsGroupLabel = (cardsGroupId) => {
        const cgData = this.props.projectData.cards_groups[cardsGroupId];
        if (!cgData) return `Registro ${cardsGroupId}`;
        return `Registro ${cgData.attributes.index || cardsGroupId}`;
    }

    render() {
        if (!this.props.teamSelectorSwitch || this.props.standByCardsGroups.length === 0) {
            return <div></div>;
        }

        const { duplicates } = findDuplicateTeamGroups(
            this.props.standByCardsGroups,
            this.props.projectData.cards_groups,
            this.props.projectData.teams
        );

        const duplicateEntries = Object.entries(duplicates);

        return (
            <div>
                <div className='sensitive-background' onClick={this.handleClose}></div>
                <div className="signature-card-layout card-color" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    <h3 className='text-center mt-2 mb-4'>{_('Seleccionar Equipo')}</h3>
                    <div className='px-4 pb-2'>
                        {duplicateEntries.map(([cardsGroupId, teams]) => (
                            <div key={cardsGroupId} className='mb-3'>
                                <p className='text mb-1'>
                                    {this.getCardsGroupLabel(cardsGroupId)}
                                </p>
                                <Select
                                    value={this.state.selections[cardsGroupId] || ''}
                                    displayEmpty={true}
                                    renderValue={(value) => {
                                        if (!value) return _('Seleccionar equipo');
                                        const team = teams.find(t => t.id === value);
                                        return team ? team.attributes.name : '';
                                    }}
                                    onChange={(e) => this.handleSelectionChange(cardsGroupId, e)}
                                    fullWidth
                                >
                                    {teams.map((team) => (
                                        <MenuItem key={team.id} value={team.id}>
                                            {team.attributes.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                        ))}
                    </div>
                    <div className='d-flex justify-content-center mt-1 mb-2'>
                        <Button
                            variant="contained"
                            className='confirm-success-button'
                            onClick={this.handleContinue}
                            disabled={!this.allSelected(duplicates)}
                        >
                            {_('Continuar')}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        projectData: state.projectData,
        standByCardsGroups: state.standByCardsGroups,
        teamSelectorSwitch: state.switches.teamSelector,
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleSwitch: toggleSwitch,
        selectedTeamIdsChange: selectedTeamIdsChange,
        popUpMenuChange: popUpMenuChange,
        selectedCardsGroupsChange: selectedCardsGroupsChange,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(TeamSelector);
